/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataCommissionPartnerDetailPageItemVo } from './PageDataCommissionPartnerDetailPageItemVo';
import {
    PageDataCommissionPartnerDetailPageItemVoFromJSON,
    PageDataCommissionPartnerDetailPageItemVoFromJSONTyped,
    PageDataCommissionPartnerDetailPageItemVoToJSON,
    PageDataCommissionPartnerDetailPageItemVoToJSONTyped,
} from './PageDataCommissionPartnerDetailPageItemVo';

/**
 * 
 * @export
 * @interface ResponsePageDataCommissionPartnerDetailPageItemVo
 */
export interface ResponsePageDataCommissionPartnerDetailPageItemVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataCommissionPartnerDetailPageItemVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataCommissionPartnerDetailPageItemVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataCommissionPartnerDetailPageItemVo}
     * @memberof ResponsePageDataCommissionPartnerDetailPageItemVo
     */
    data?: PageDataCommissionPartnerDetailPageItemVo;
}

/**
 * Check if a given object implements the ResponsePageDataCommissionPartnerDetailPageItemVo interface.
 */
export function instanceOfResponsePageDataCommissionPartnerDetailPageItemVo(value: object): value is ResponsePageDataCommissionPartnerDetailPageItemVo {
    return true;
}

export function ResponsePageDataCommissionPartnerDetailPageItemVoFromJSON(json: any): ResponsePageDataCommissionPartnerDetailPageItemVo {
    return ResponsePageDataCommissionPartnerDetailPageItemVoFromJSONTyped(json, false);
}

export function ResponsePageDataCommissionPartnerDetailPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataCommissionPartnerDetailPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataCommissionPartnerDetailPageItemVoFromJSON(json['data']),
    };
}

export function ResponsePageDataCommissionPartnerDetailPageItemVoToJSON(json: any): ResponsePageDataCommissionPartnerDetailPageItemVo {
    return ResponsePageDataCommissionPartnerDetailPageItemVoToJSONTyped(json, false);
}

export function ResponsePageDataCommissionPartnerDetailPageItemVoToJSONTyped(value?: ResponsePageDataCommissionPartnerDetailPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataCommissionPartnerDetailPageItemVoToJSON(value['data']),
    };
}

